import { Splide, SplideSlide } from "@splidejs/react-splide";
import React from "react";
import LoaderGameList from "./LoadingGameList";

import { Grid } from "@splidejs/splide-extension-grid";
import LoadingImage from "./LoadingImage";
import LoadingLine from "./LoadingLine";

const LoadingForLiveLayout = ({ itemClass }) => {
  return (
    <div className="px-common-padding-x">
      <section className="flex justify-between h-[35px] mb-[5px]">
        <div className="flex items-center">
          <LoadingImage
            closeInverted
            className={`w-[130px] h-[20px] rounded-full`}
          ></LoadingImage>
        </div>
        <div className="flex items-center gap-[5px]">
          <>
            <div className="bg-base-deep-gray dark:bg-base-light-dark dark:text-base-white text-base-light-dark cursor-pointer py-[8px] px-[10px] h-[40px] font-medium text-sm flex items-center rounded-[5px]">
              <LoadingLine
                className={`!w-[60px] !h-[10px] !mt-0`}
              ></LoadingLine>
            </div>
          </>
        </div>
      </section>

      <Splide
        className={`h-full w-full`}
        extensions={{ Grid }}
        options={{
          type: "slide",
          pagination: false,
          arrows: false,
          drag: "free",
          perMove: 1,
          perPage: 3,
          gap: 10,
          lazyLoad: "nearby",
          dragMinThreshold: {
            mouse: 0,
            touch: 10,
          },
          preloadPages: 3,
          keyboard: false,
          breakpoints: {
            640: {
              perPage: 1,
              grid: {
                dimensions: [[2, 2]],
                gap: {
                  row: 10,
                  col: 10,
                },
              },
            },
            768: {
              perPage: 3,
            },
            1024: {
              perPage: 3,
            },
            1280: {
              perPage: 3,
            },
          },
        }}
      >
        {Array.from({ length: 8 }, (_, i) => (
          <SplideSlide key={`loading-${i}`}>
            <LoaderGameList
              commonLoading={true}
              className={`${itemClass} lg:h-[185px] md:h-[160px] h-[130px]`}
            />
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default LoadingForLiveLayout;
